export interface BitmapTextStyleData {
    fontName: string;
    fontSize?: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}

/**
 * Class description
 *
 * Created: 2017-09-22
 * @author jonas
 */

export class DungeonQuestTextStyles {

    public static BIG_WIN_DISPLAY_NUMBERS:BitmapTextStyleData = {
        fontName:"fifthCountUp",
        fontSize:180,
        tint:0xffffff
    };
    public static BIG_WIN_DISPLAY_NUMBERS_WHITE:BitmapTextStyleData = {
        fontName:"fifthCountUpWhite",
        fontSize:180,
        tint:0xffffff
    };

    public static WIN_DISPLAY_NUMBERS:BitmapTextStyleData = {
        fontName:"fifthCountUp",
        fontSize:110,
        tint:0xffffff
    };
    public static WIN_DISPLAY_NUMBERS_WHITE:BitmapTextStyleData = {
        fontName:"fifthCountUpWhite",
        fontSize:110,
        tint:0xffffff
    };
}